import { createClient } from '@supabase/supabase-js';

// Resolve credentials from environment, fallback to known project values to prevent login breakage
const fallbackUrl = 'https://vfpajtgpxinvbkeripdd.supabase.co';
const fallbackKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZmcGFqdGdweGludmJrZXJpcGRkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAzOTA0ODcsImV4cCI6MjA1NTk2NjQ4N30.xO9O2MV7JVHXl81MvqnDXraNucAsWsWaD6sfTmqSNIA';
const supabaseUrl = (process.env.REACT_APP_SUPABASE_URL || process.env.SUPABASE_URL || fallbackUrl) as string;
const supabaseKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.SUPABASE_ANON_KEY || fallbackKey) as string;

const memoryStorage = new Map<string, string>();

// Create and export the Supabase client with Safari-specific configuration
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce', // Use PKCE flow for better Safari compatibility
    storage: {
      // Custom storage implementation for Safari compatibility
      getItem: (key: string) => {
        try {
          if (typeof localStorage !== 'undefined') return localStorage.getItem(key);
          if (typeof sessionStorage !== 'undefined') return sessionStorage.getItem(key);
          return memoryStorage.get(key) ?? null;
        } catch (error) {
          try {
            if (typeof sessionStorage !== 'undefined') return sessionStorage.getItem(key);
            return memoryStorage.get(key) ?? null;
          } catch {
            return memoryStorage.get(key) ?? null;
          }
        }
      },
      setItem: (key: string, value: string) => {
        try {
          if (typeof localStorage !== 'undefined') {
            localStorage.setItem(key, value);
            return;
          }
          if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem(key, value);
            return;
          }
          memoryStorage.set(key, value);
        } catch (error) {
          try {
            if (typeof sessionStorage !== 'undefined') {
              sessionStorage.setItem(key, value);
              return;
            }
            memoryStorage.set(key, value);
          } catch {
            memoryStorage.set(key, value);
          }
        }
      },
      removeItem: (key: string) => {
        try {
          if (typeof localStorage !== 'undefined') {
            localStorage.removeItem(key);
            return;
          }
          if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem(key);
            return;
          }
          memoryStorage.delete(key);
        } catch (error) {
          try {
            if (typeof sessionStorage !== 'undefined') {
              sessionStorage.removeItem(key);
              return;
            }
            memoryStorage.delete(key);
          } catch {
            memoryStorage.delete(key);
          }
        }
      }
    }
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'X-Client-Info': 'supabase-js-web'
    }
  }
});
